<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Carreras</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nueva Carrera
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="programs"
        :fields="fields"
        :busy="loading"
        @update:items="onItemsUpdate"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
          </div>
        </template>

        <template #cell(facultadNombre)="data">
          <span>{{ data.value || 'Sin asignar' }}</span>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
            {{ data.value ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteProgram(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <program-modal
      :program-data="selectedProgram"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge, BSpinner,
} from 'bootstrap-vue'
import ProgramModal from '@/components/programs/ProgramModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import carrerasService from '@/services/carrerasService'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BSpinner,
    ProgramModal,
  },
  data() {
    return {
      fields: [
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'facultadNombre', label: 'Facultad', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      programs: [],
      selectedProgram: null,
      loading: false,
    }
  },
  async mounted() {
    await this.loadPrograms()
  },
  methods: {
    onItemsUpdate(items) {
      console.log('Tabla actualizada con items:', items)
    },
    async loadPrograms() {
      this.loading = true
      try {
        const response = await carrerasService.getAll()
        console.log('Respuesta completa del servicio:', response)
        console.log('Tipo de respuesta:', typeof response)
        console.log('Es array:', Array.isArray(response))
        
        // La respuesta viene directamente como array del servicio
        this.programs = response
        console.log('Carreras asignadas a this.programs:', this.programs)
        console.log('Cantidad de carreras:', this.programs.length)
        
        // Verificar estructura de los datos
        if (this.programs.length > 0) {
          console.log('Primera carrera:', this.programs[0])
          console.log('Campos disponibles:', Object.keys(this.programs[0]))
        }
      } catch (error) {
        console.error('Error al cargar carreras:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al cargar las carreras',
          },
        })
      } finally {
        this.loading = false
      }
    },
    openModal(item) {
      this.selectedProgram = item ? { ...item } : null
      this.$bvModal.show('program-modal')
    },
    async handleModalSubmit(data) {
      try {
        if (data.carreraId) {
          // Actualizar
          await carrerasService.update(data.carreraId, {
            codigo: data.codigo,
            nombre: data.nombre,
            facultadId: data.facultadId,
            estado: data.estado,
          })
        } else {
          // Crear
          await carrerasService.create({
            codigo: data.codigo,
            nombre: data.nombre,
            facultadId: data.facultadId,
            estado: data.estado,
          })
        }
        
        await this.loadPrograms()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operación Exitosa',
            icon: 'CheckIcon',
            variant: 'success',
            text: `La carrera se ha ${data.carreraId ? 'actualizado' : 'creado'} correctamente.`,
          },
        })
      } catch (error) {
        console.error('Error al guardar carrera:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al guardar la carrera',
          },
        })
      }
    },
    async deleteProgram(item) {
      try {
        await this.$swal({
          title: '¿Estás seguro?',
          text: '¡No podrás revertir esto!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, ¡elimínala!',
          cancelButtonText: 'Cancelar',
          customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
          buttonsStyling: false,
        })

        await carrerasService.delete(item.carreraId)
        await this.loadPrograms()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Eliminada',
            icon: 'TrashIcon',
            variant: 'success',
            text: 'La carrera ha sido eliminada.',
          },
        })
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error al eliminar carrera:', error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'Error al eliminar la carrera',
            },
          })
        }
      }
    },
  },
}
</script>
